const THEME_NAME_SEPARATOR = "_",
  THEME_CLASSNAME_PREFIX = "t_",
  FONT_DATA_ATTRIBUTE_NAME = "data-tamagui-font",
  stackDefaultStyles = {},
  webViewFlexCompatStyles = {
    display: "flex",
    alignItems: "stretch",
    flexDirection: "column",
    flexBasis: "auto",
    // @ts-expect-error
    boxSizing: "border-box",
    position: process.env.TAMAGUI_POSITION_STATIC === "1" ? "static" : "relative",
    minHeight: 0,
    minWidth: 0,
    flexShrink: 0
  };
Object.assign(stackDefaultStyles, webViewFlexCompatStyles);
export { FONT_DATA_ATTRIBUTE_NAME, THEME_CLASSNAME_PREFIX, THEME_NAME_SEPARATOR, stackDefaultStyles, webViewFlexCompatStyles };
//# sourceMappingURL=constants.mjs.map
